"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1.807-4c-3.962-.923-4.266-5.1-2.743-7.077C8 10.21 8.59 9.8 9.147 9.412c.987-.687 1.874-1.304 2.265-3.412 3.048 1.846 2.388 6 2.388 6s1.879-1.077 1.27-3.538c4.266 3.692 1.828 8.307-.61 9.23-1.524.577-3.962-1.846-3.658-4.923-2.743 2.154-.61 5.231-.61 5.231z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;